import { Route } from "components/utils";
import { NotFound } from "pages/notFound";
import { WarehousemanList } from "pages/wms/warehousemanList/WarehousemanList";
import { Redirect, RouteComponentProps, Switch } from "react-router-dom";

export const Warehouseman = ({ match }: RouteComponentProps): JSX.Element => {
  return (
    <Switch>
      <Route
        exact={true}
        path={`${match.path}`}
        render={() => <Redirect to={`${match.path}/list/all`} />}
      />
      <Route
        exact={true}
        path={`${match.path}/list`}
        render={() => <Redirect to={`${match.path}/list/all`} />}
      />
      <Route
        component={WarehousemanList}
        exact={true}
        path={`${match.path}/list/:tab`}
        title="Milo - WMS - magazynierzy"
      />
      <Route component={NotFound} exact={true} path="*" title="Milo" />
    </Switch>
  );
};
